export default __webpack_public_path__ + "static/media/07-participate.c1d9aa0d.png";